import React from 'react';
import PermissionAccessManagement from './PermissionAccessManagement';

// Kept as a route entry for existing bookmarks. Account creation and role binding
// intentionally use the same server-backed panel as /settings.
export default function AdminAccountManagement() {
  return <div className="p-4 sm:p-6 lg:p-8"><PermissionAccessManagement initialTab="accounts" /></div>;
}
